<div class="product-grid-wrapper">
  <!-- Header row: label + view toggle -->
  <div class="pg-header">
    <h3 class="pg-header__title">
      {{ categoryLabel }}
      <span
        *ngIf="showCount && displayedProducts.length > 0"
        class="pg-header__count"
      >
        ({{ displayedProducts.length }})
      </span>
    </h3>
    <!-- <div class="pg-view-toggle">
      <button
        class="pg-toggle-btn"
        [class.pg-toggle-btn--active]="viewMode === 'grid'"
        (click)="setViewMode('grid')"
        title="Grid view"
      >
        <i class="pi pi-th-large"></i>
        <span>Grid</span>
      </button>
      <button
        class="pg-toggle-btn"
        [class.pg-toggle-btn--active]="viewMode === 'list'"
        (click)="setViewMode('list')"
        title="List view"
      >
        <i class="pi pi-list"></i>
        <span>List</span>
      </button>
    </div> -->
  </div>

  <!-- Empty state -->
  <div *ngIf="displayedProducts.length === 0" class="pg-empty">
    <i class="pi pi-inbox pg-empty__icon"></i>
    <p class="pg-empty__text">No items in this category</p>
  </div>

  <!-- GRID VIEW -->
  <div
    *ngIf="viewMode === 'grid' && displayedProducts.length > 0"
    class="pg-grid"
  >
    <div
      *ngFor="let product of displayedProducts; trackBy: trackByProductId"
      class="pg-card pos-product-card"
      (click)="onProductClick(product)"
      (keydown.enter)="onProductClick(product)"
      (keydown.space)="onProductClick(product)"
      role="button"
      tabindex="0"
      [title]="product.name"
    >
      <!-- Product image container -->
      <div class="pg-card__img-wrap">
        <img
          [src]="getProductImage(product)"
          [alt]="product.name"
          class="pg-card__img"
          (error)="onImageError($event)"
        />
        <!-- Stock status pill badge -->
        <span class="stock-badge" [ngClass]="getStockStatusClass(product)">
          {{ getStockLabel(product) }}
        </span>
      </div>

      <!-- Info -->
      <div class="pg-card__info">
        <!-- Top: Name & Price -->
        <div class="pg-card__header-row">
          <div class="pg-card__name" [title]="product.name">
            {{ product.name }}
          </div>
          <div class="pg-card__price">
            {{
              getDisplayPrice(product) | currency: "INR" : "symbol" : "1.0-2"
            }}
          </div>
        </div>

        <!-- Category Text -->
        <div
          class="pg-card__category"
          *ngIf="product.category || product.category_name"
        >
          {{ product.category || product.category_name }}
        </div>

        <!-- Footer: Unit & Add to cart button / Qty Stepper -->
        <div class="pg-card__footer">
          <!-- Add to Cart (not in cart yet) -->
          <ng-container *ngIf="getCartQty(product) === 0; else gridStepper">
            <!-- <span *ngIf="product.unit" class="pg-card__unit">{{
              product.unit
            }}</span> -->
            <button
              class="pg-card__add-btn"
              (click)="onProductClick(product); $event.stopPropagation()"
              [title]="'Add ' + product.name"
              [attr.aria-label]="'Add ' + product.name + ' to cart'"
            >
              Add
            </button>
          </ng-container>

          <!-- Qty Stepper (already in cart) -->
          <ng-template #gridStepper>
            <div class="pg-card__stepper" (click)="$event.stopPropagation()">
              <button
                class="pg-card__stepper-btn pg-card__stepper-btn--minus"
                (click)="
                  decreaseQty.emit(getCartItem(product));
                  $event.stopPropagation()
                "
                [disabled]="getCartQty(product) <= 1"
                title="Decrease quantity"
              >
                <i class="pi pi-minus"></i>
              </button>
              <span class="pg-card__stepper-val">{{
                getCartQty(product)
              }}</span>
              <button
                class="pg-card__stepper-btn pg-card__stepper-btn--plus"
                (click)="
                  increaseQty.emit(getCartItem(product));
                  $event.stopPropagation()
                "
                title="Increase quantity"
              >
                <i class="pi pi-plus"></i>
              </button>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <!-- LIST VIEW -->
  <div
    *ngIf="viewMode === 'list' && displayedProducts.length > 0"
    class="pg-list"
  >
    <div
      *ngFor="let product of displayedProducts; trackBy: trackByProductId"
      class="pg-list-row"
      (click)="onProductClick(product)"
      (keydown.enter)="onProductClick(product)"
      role="button"
      tabindex="0"
      [title]="product.name"
    >
      <div class="pg-list-row__img-wrap">
        <img
          [src]="getProductImage(product)"
          [alt]="product.name"
          class="pg-list-row__img"
          (error)="onImageError($event)"
        />
      </div>
      <div class="pg-list-row__info">
        <div class="pg-list-row__name">{{ product.name }}</div>
        <div class="pg-list-row__meta">
          <span
            class="pg-list-row__category"
            *ngIf="product.category || product.category_name"
          >
            {{ product.category || product.category_name }}
          </span>
          <span class="pg-list-row__desc-text" *ngIf="product.description">
            · {{ product.description }}
          </span>
        </div>
      </div>
      <div class="pg-list-row__price">
        {{ getDisplayPrice(product) | currency: "INR" : "symbol" : "1.0-2" }}
        <span *ngIf="product.unit" class="pg-list-row__unit"
          >/ {{ product.unit }}</span
        >
      </div>
      <!-- Add to Cart (not in cart yet) -->
      <button
        *ngIf="getCartQty(product) === 0; else listStepper"
        class="pg-list-row__add-btn"
        (click)="onProductClick(product); $event.stopPropagation()"
        [attr.aria-label]="'Add ' + product.name"
      >
        <i class="pi pi-plus"></i> Add
      </button>

      <!-- Qty Stepper (already in cart) -->
      <ng-template #listStepper>
        <div class="pg-card__stepper" (click)="$event.stopPropagation()">
          <button
            class="pg-card__stepper-btn pg-card__stepper-btn--minus"
            (click)="decreaseQty.emit(product); $event.stopPropagation()"
            [disabled]="getCartQty(product) <= 1"
            title="Decrease quantity"
          >
            <i class="pi pi-minus"></i>
          </button>
          <span class="pg-card__stepper-val">{{ getCartQty(product) }}</span>
          <button
            class="pg-card__stepper-btn pg-card__stepper-btn--plus"
            (click)="increaseQty.emit(product); $event.stopPropagation()"
            title="Increase quantity"
          >
            <i class="pi pi-plus"></i>
          </button>
        </div>
      </ng-template>
    </div>
  </div>
</div>
